import { Table, Select, DatePicker, Row, Col, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';

const { RangePicker } = DatePicker;

class TablaRecibosContravencion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  sortFechas = (a, b) => {
    let fechaA = a.fechaDeposito ? a.fechaDeposito : a.fechaCreacion;
    let fechaB = b.fechaDeposito ? b.fechaDeposito : b.fechaCreacion;

    if (fechaA > fechaB) {
      // console.log("A");
      return 1;
    }
    if (fechaA < fechaB) {
      // console.log("B");
      return -1;
    }

    if (fechaA == fechaB) {
      // console.log("C");
      return 0;
    }
  };

  render() {
    const columns = [
      {
        title: 'Fecha',
        key: 'fecha',
        render: record => moment(record.fechaCreacion).format('DD/MM/YYYY'),
        defaultSortOrder: 'descend',
        sorter: (a, b) => this.sortFechas(a, b),
      },
      {
        title: 'Organismo',
        key: 'organismo',
        render: record => record.nombre,
        dataIndex: 'organismo',
      },
      {
        title: 'Importe',
        key: 'importe',
        render: record =>
          record.contraventor && record.contraventor.sancion
            ? record.contraventor.sancion.monto.toLocaleString('es-AR', {
                style: 'currency',
                currency: 'ARS',
              })
            : 'SIN DATOS',
      },
      {
        title: 'Numero',
        key: 'numero',
        dataIndex: 'numero',
      },
      {
        title: 'Depositado',
        key: 'pagado',
        render: record => (record.pagado ? 'SI' : 'SIN DEPOSITAR'),
      },
      {
        title: 'Contraventor del Recibo',
        key: 'nombre',
        dataIndex: 'nombre',
        render: nombre => nombre.toUpperCase(),
      },
    ];
    const { recibos, usuario, organismos } = this.props;

    return (
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={recibos}
        style={{ fontSize: 9 }}
        size="small"
        pagination={false}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center', marginTop: 40 }}>
              Tabla de Recibos Contravencionales
            </h2>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col>
                <Button
                  style={{ marginRight: 10 }}
                  type="danger"
                  onClick={() => this.props.verTabla(false)}
                >
                  Atras
                </Button>
              </Col>
              <Col>
                <Button
                  style={{ marginRight: 10 }}
                  type="primary"
                  onClick={() => this.props.onDescargar()}
                >
                  <Icons.DownloadOutlined />
                  Descargar Reporte
                </Button>
              </Col>
            </Row>
          </div>
        )}
        locale={{
          emptyText: 'Sin datos de Recibos Contravencionales.',
        }}
      />
    );
  }
}

export default TablaRecibosContravencion;
